import {inheritPrototype, isDef} from '../util/util'
import echarts from 'echarts'
import Base from './base'


// 折线图和柱状图 混合
var PictorialBar = function (dataList, type) {
    Base.call(this)
    this.type = type
    if (dataList) {
        this.xList = isDef(dataList.xList) ? dataList.xList : []
        this.yList = isDef(dataList.yList) ? dataList.yList : []
        this.optionSet = isDef(dataList.optionSet) ? dataList.optionSet : {}
    } else {
        this.xList = []
        this.yList = []
        this.optionSet = {}
    }

    this.init()
}
inheritPrototype(PictorialBar, Base)
PictorialBar.prototype.init = function () {
    // this.option.toolbox = this.getToolbox()
   // let axisLabelColor = isDef(this.optionSet.xAxisLabelColor) ? this.optionSet.xAxisLabelColor : []
    this.option.grid = this.getGrid()
    this.option.tooltip = this.getTooltip()
    let xaxis = this.getXAxis()
    let x = []
    for (let item of this.xList) {
        if (isDef(item) && item.indexOf('_') > -1) {
            x.push(item.split('_', -1)[0])
        } else {
            x.push(item)
        }
    }
    xaxis[0].data = x
    /*   if (x.length > axisLabelColor.length) {
          for (let i  in x) {
              if (!isDef(axisLabelColor[i])) {
                  axisLabelColor[i] = randomRgbColor();
              }
          }
      }
     xaxis[0].axisLabel.rich = [];
      for (let j in x) {
          xaxis[0].axisLabel.rich[j] = {
              "height": 20,
              "align": "center",
              "width": 40,
              "backgroundColor": axisLabelColor[j],
              "color": "#fff",
              fontWeight: 400,
              "fontSize": 12,
              "borderWidth": 1,
              "borderRadius": 34
          }
    }*/
    this.option.xAxis = xaxis
    this.option.series = this.getSeries()
    this.option.yAxis = this.getYAxis()
    // this.option.legend = this.getLegend(this.option.series)
}
PictorialBar.prototype.getYAxis = function () {
    return {
        name: isDef(this.optionSet.unit1) ? '单位:' + this.optionSet.unit1 : '',
        nameTextStyle: {
            padding: [0, 0, 0, 20],
            color: '#ffffff' // y轴的单位字体样式
        },
        splitLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLine: {
            show: false
        },
        axisLabel: {
            show: false
        }
    }
}
PictorialBar.prototype.getXAxis = function () {
    let splitLineShow = this.optionSet.isShowXAxisSplitLine
    // let rotate = isDef(this.optionSet.rotate) ? this.optionSet.rotate : 0
    return [
        {
            type: 'category',
            data: [],
            axisLabel: {
                // color: isDef(axisLabelColor) ? axisLabelColor : '#383D44',// x轴的标记字体颜色
                color: '#00EAFF'
                /*  formatter: function (val, index) {
                      return '{' + index + '|' + val + '}';
                  },*/
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#E3E5E9',
                    opacity: 0.6
                }
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: isDef(splitLineShow) ? splitLineShow : false, // x分割线的显示
                lineStyle: {
                    type: 'dotted',
                    color: '#E3E5E9',
                    opacity: 0.3
                }
            }
        }
    ]
}
PictorialBar.prototype.getSeries = function () {
    let series = []
    if (this.yList) {
        let isShowLabel = isDef(this.optionSet.isShowLabel) ? this.optionSet.isShowLabel : false;
        let isSymbolRepeat = isDef(this.optionSet.isSymbolRepeat) ? this.optionSet.isSymbolRepeat : false;
        let i = 0;
        for (let item of this.yList) {
            let colorList = isDef(item.color) ? item.color : ['rgb(164,205,238)', 'rgb(42,170,227)', 'rgb(25,46,94)', 'rgb(195,229,235)']
            // let colorListCoordinate = isDef(item.colorListCoordinate) ? item.colorListCoordinate : [1, 1, 1, 1];
            let symbol = isDef(item.symbol) ? item.symbol : 'react';
            let symbolSize = isDef(item.symbolSize) ? item.symbolSize : [];
            let symbolPosition = isDef(item.symbolPosition) ? item.symbolPosition : '';
            let symbolOffset = isDef(item.symbolOffset) ? item.symbolOffset : [];
            let barWidth = isDef(item.barWidth) ? item.barWidth : '100%';
            let z = isDef(item.z) ? item.z : 99;
            let d = {
                type: 'pictorialBar',
                name: item.name,
                data: item.data,
                barWidth: barWidth,
                barGap: '10%',
                z: z,
                symbolSize: symbolSize,
                symbolPosition: symbolPosition,
                //柱子显示的样式，'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
                symbol: symbol,
                symbolRepeat: isSymbolRepeat,
                itemStyle: {
                    normal: {
                        color: function () {
                            return new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                offset: 0,
                                color: colorList[0]
                            }, {offset: 1, color: colorList[1]}]);
                        },
                        opacity: 1,
                        label: {
                            show: isShowLabel,		// 开启显示
                            position: 'top',	// 在上方显示
                            textStyle: { // 数值样式
                                color: colorList[i],
                                fontSize: 14
                            },
                            borderRadius: 5,
                            padding: [5, 10, 5, 10]
                        }
                    }
                }
            }
            if (symbolSize.length > 0) {
                d.symbolSize = symbolSize;
            }
            if (symbolOffset.length > 0) {
                d.symbolOffset = symbolOffset;
            }
            series.push(d)
            i++;
        }
    }
    return series
}
PictorialBar.prototype.getTooltip = function () {
    let axisPointerType = isDef(this.optionSet.axisPointerType) ? this.optionSet.axisPointerType : 'line'
    return {
        trigger: 'axis',
        formatter: '{b}<br/> {c0}<br />',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: axisPointerType // 默认为直线，可选为：'line' | 'shadow'
        }
    }
}

export default PictorialBar
